import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { ContentLibraryFolderApi } from './models/content-library-folder.api.model';
import { UpdateLibraryContentRequestApi } from './models/content-library-media.api.model';
import { MultiBaseAbstractApi } from '../../api/genericApi/multi-base-abstract.api';
@Injectable()
export class ContentLibraryFolderApiService extends MultiBaseAbstractApi<ContentLibraryFolderApi, ContentLibraryFolderApi> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }



    getList(): Observable<ContentLibraryFolderApi[]> {
        return this.neptuneApi.api<ContentLibraryFolderApi[]>(
            '/content/libraries',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    create(folder: ContentLibraryFolderApi): Observable<number> {
        return this.neptuneApi.api<number>(
            '/content/libraries',
            folder,
            HttpVerbsEnum.POST
        );
    }

    update(folder: ContentLibraryFolderApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/content/libraries/${folder.id}`,
            folder,
            HttpVerbsEnum.PUT
        );
    }

    deleteById(libraryId: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/content/libraries/${libraryId}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    updateLibraryContent(libraryId: string, request: UpdateLibraryContentRequestApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/content/libraries/${libraryId}`,
            request,
            HttpVerbsEnum.POST
        );
    }
}
